export default __webpack_public_path__ + "static/media/pantry1-afterG-2048w.0c0a68d5.avif";